module.exports = __webpack_public_path__ + "static/img/materialsInfo1t5.c98262c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo1t5.png
// module id = M+01
// module chunks = 2